import { useCallback } from "react";
import { useBlockPanelPropsContext } from "../../lib/panel/panel-container";
import { PanelVariableInputContent } from "../../lib/panel/panel-variable-input-content";
import { Block } from "../blocks-types";

export function EmailPanelUrl() {
  const blockProps = useBlockPanelPropsContext();
  const { formAPI } = blockProps;
  const block: Block<"banner"> = blockProps.block as Block<"banner">;

  const item = block.properties?.items?.[0];

  const handleSave = useCallback(
    (href: string) => {
      if (!item) return;

      formAPI.updateField(`${formAPI.blockPath}.properties.items.0`, {
        href: href,
        imageUrl: item.imageUrl,
        imageId: item.imageId,
        imageUploadKey: item.imageUploadKey,
      });
    },
    [formAPI, item],
  );

  return (
    <PanelVariableInputContent
      title="Url"
      value={item?.href ?? ""}
      onChange={handleSave}
      variables={blockProps.variables}
      id="banner-href"
      triggerOnChange
    />
  );
}
